export default __webpack_public_path__ + "img/djZLrtVd.43b10d04.svg";